/**
 * Customer features the backend can enable per customer (Django `Feature`
 * rows — `key` is the slugified admin name). Keep in sync with the backend
 * admin; an unknown key here silently reads as disabled.
 */
export const FEATURE_KEYS = [
  'app_management',
  'search',
  'weather',
  'employee_time_clock_stats',
  'dvr',
  'maintenance_report',
  'events',
  'forms',
  'operator_schedule',
  'locations',
  'crm',
  'vehicle_state_report',
  'reports',
  'chats',
  'notifications',
  'projects',
  'project_tasks_management',
  'signal_level',
  'seconds_behind',
  'battery_charts',
  'task_route_display',
  'webrtc_video_player',
  'assets',
  'drive_documents',
  'bot_view_json',
] as const;

export type FeatureKey = (typeof FEATURE_KEYS)[number];

const FEATURE_LABEL_OVERRIDES: Partial<Record<FeatureKey, string>> = {
  dvr: 'DVR',
  crm: 'CRM',
  webrtc_video_player: 'WebRTC Video Player',
  bot_view_json: 'Bot View JSON',
};

/** Human-readable flag name: the override when set, Title Cased key otherwise. */
export function getFeatureLabel(key: FeatureKey): string {
  return (
    FEATURE_LABEL_OVERRIDES[key] ??
    key
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  );
}

export interface Feature {
  desc: string;
  key: FeatureKey;
  name: string;
}
